import React from "react";
import { ThemeProvider, ThemeProviderComponent } from "styled-components";
import { SpacingStyle } from "core/styles/paddingMarginStyle";

import { Container, Bar, Desc, Text, TextCounter } from "./_progressStyle";

type ProgressProps = {
  value?: number;
  desc?: string;
  totalCount?: number;
  isCounter?: boolean;
  isAnimated?: boolean;
  errorLabel?: React.ReactNode;
  height?: string | number;
  initialWidth?: number;
  width?: string | number;
  color?: string;
  threshold?: number;
  thresholdWidth?: number;
  thresholdColor?: string;
  variant?: "primary" | "secondary" | "gradient";
  hideTextCounter?: boolean;
} & SpacingStyle;

function Progress(props: ProgressProps) {
  const {
    desc,
    value,
    totalCount,
    errorLabel,
    isCounter,
    variant,
    isAnimated,
    initialWidth,
    color,
    threshold,
    thresholdColor,
    thresholdWidth,
    hideTextCounter,
    ...rest
  } = props;

  return (
    <ThemeProvider theme={{ variant }}>
      <Container {...rest}>
        <Desc>{desc}</Desc>
        {threshold && (
          <Bar
            className={`progress-bar-fill threshold ${isAnimated && "animated-progress"}`}
            color={thresholdColor || ""}
            width={thresholdWidth || 0}
            value={threshold || 0}
            isCounter={false}
            totalCount={0}
            initialWidth={0}
          />
        )}
        <Bar
          className={`progress-bar-fill  ${isAnimated && "animated-progress"}`}
          color={color || ""}
          width={value || 0}
          value={value || 0}
          initialWidth={initialWidth || 0}
          totalCount={totalCount || 0}
          isCounter={!!isCounter}>
          {!isCounter && variant === "gradient" && (
            <Text>{value === 100 ? "Completed" : `${value || 0}%`}</Text>
          )}
        </Bar>
        {isCounter && (
          // @ts-expect-error TS(2769): No overload matches this call.
          <TextCounter value={value} totalCount={totalCount}>
            {`${value} / ${totalCount}`}
          </TextCounter>
        )}
        {isCounter && errorLabel}
      </Container>
    </ThemeProvider>
  );
}

Progress.defaultProps = {
  desc: "",
  value: 0,
  totalCount: 0,
  isCounter: false,
  errorLabel: null,
  height: 30,
  initialWidth: 0,
  width: "100%",
  variant: "primary",
  isAnimated: false,
};

export default Progress;
